// extracted by mini-css-extract-plugin
module.exports = {"categoriesList":"categories-list_categoriesList__JgTbr"};